import React, { useState } from "react";
import dayjs from "dayjs";

import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
  Box
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import authService from "../Auth/AuthService";

const getShift = (time) => {
  const h = time.hour();
  if (h >= 6 && h < 14) return "MORNING";
  if (h >= 14 && h < 22) return "EVENING";
  return "NIGHT";
};

export default function LeaveForm({ empId, onSuccess }) {

  const [isEditing, setIsEditing] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [formData, setFormData] = useState({
    empId,
    attendDate: "",
    leaveType: "",
    reason: ""
  });

  const [inTime, setInTime] = useState(null);
  const [outTime, setOutTime] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleInTimeChange = (value) => {
    setInTime(value);
  };

  const handleOutTimeChange = (value) => {
    setOutTime(value);
  };

  const loadEditData = () => {

    const apiData = {
      attendDate: "2026-02-14",
      leaveType: "SICK",
      reason: "Fever",
      inTime: "09:30:00",
      outTime: "18:15:00"
    };

    setFormData({
      attendDate: apiData.attendDate,
      leaveType: apiData.leaveType,
      reason: apiData.reason
    });

    // ⭐ CRITICAL conversion
    setInTime(apiData.inTime ? dayjs(apiData.inTime, "HH:mm:ss") : null);
    setOutTime(apiData.outTime ? dayjs(apiData.outTime, "HH:mm:ss") : null);

    setIsEditing(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    const autoShift = getShift(dayjs(inTime));
    const payload = {
      ...formData,
      shift: autoShift,
      month: dayjs(formData.attendDate).format("MMMM").toUpperCase(),
      inTime: inTime ? inTime.format("HH:mm:ss") : null,
      outTime: outTime ? outTime.format("HH:mm:ss") : null
    };
    console.log("SEND TO API:", payload);
    await authService.postAuth(
      authService.pathUrl("POST", "/attendance/leave-entry"),
      payload
    );
    if (onSuccess) onSuccess();
    setTimeout(() => setIsDisabled(false), 1000);
  };

  const resetForm = () => {
    setFormData({ attendDate: "", leaveType: "", reason: "" });
    setInTime(null);
    setOutTime(null);
    setIsEditing(false);
  };

  return (

    <LocalizationProvider dateAdapter={AdapterDayjs}>

      <Container maxWidth="md">
        <Card sx={{ mb: 4 }}>
          <CardContent>

            <Typography
              variant="h6"
              textAlign="center"
              sx={{ mb: 2 }}
            >
              {isEditing ? "Update Leave" : "Add Leave"}
            </Typography>

            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap={2}>

                <TextField
                  type="date"
                  label="Select Date"
                  name="attendDate"
                  size="small"
                  value={formData.attendDate}
                  onChange={handleChange}
                  slotProps={{ inputLabel: { shrink: true } }}
                  required
                />

                <TimePicker
                  label="In Time"
                  value={inTime}
                  onChange={handleInTimeChange}
                />

                <TimePicker
                  label="Out Time"
                  value={outTime}
                  onChange={handleOutTimeChange}
                  disabled={!inTime}
                />

                <TextField
                  select
                  size="small"
                  label="Leave Type"
                  name="leaveType"
                  value={formData.leaveType}
                  onChange={handleChange}
                  required
                >
                  {[
                    "MATERNITY",
                    "PATERNITY",
                    "COMPENSATORY_OFF",
                    "LOSS_OF_PAY",
                    "EARNED",
                    "SICK",
                    "CASUAL"
                  ].map((m) => (
                    <MenuItem key={m} value={m}>
                      {m}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Reason"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                />

                <Button sx={{ bgcolor: '#332c1b', borderRadius: 2 }}
                  type="submit"
                  variant="contained"
                  disabled={isDisabled}
                >
                  {isDisabled
                    ? <CircularProgress size={20} />
                    : (isEditing ? "Update" : "Add")}
                </Button>

                {/* <Button onClick={loadEditData}>
                  Load Fake Edit Data
                </Button> */}

                {isEditing && (
                  <Button onClick={resetForm}>
                    Cancel
                  </Button>
                )}

              </Box>
            </form>

          </CardContent>
        </Card>
      </Container>

    </LocalizationProvider>
  );
}
